import { render, staticRenderFns } from "./BankFlowList.vue?vue&type=template&id=59519a2d&scoped=true&"
import script from "./BankFlowList.vue?vue&type=script&lang=js&"
export * from "./BankFlowList.vue?vue&type=script&lang=js&"
import style0 from "./BankFlowList.vue?vue&type=style&index=0&id=59519a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59519a2d",
  null
  
)

export default component.exports